import React, { Component } from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from "react-router-dom";

import ColumnFormatter from '../../common/ColumnFormatter';

export class ApplicantList extends Component {
    displayName = "Applicants";

    constructor(props) {
        super(props);

        this.state = {
            persons: [],
            loading: true,
            onlyActive: false,
            successfulPost: null
        };

        this.toggleActiveClients();
    }

    postClient(data) {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                firstName: data.firstName,
                middleName: data.middleName,
                lastName: data.lastName,
                email: data.email,
                phoneNumber: data.phoneNumber,
                address: data.address
            })
        };

        fetch(`api/PollService/${localStorage.getItem('agency_key')}/client`, requestOptions)
            .then(response => response.json());

        this.forceUpdate();
        window.location.reload();
    }


    onAfterInsertRow = row => {
        this.postClient(row);
    }

    onAddRow = row => {
        row.id = 0;

        if (row.lastName.length < 3) {
            alert("Last Name: At least 3 characters required");
            return;
        }

        if (row.firstName.length < 3) {
            alert("First Name: At least 3 characters required");
            return;
        }

        // eslint-disable-next-line
        if (row.email && !row.email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/i)) {
            alert("Email is not valid");
            return;
        }

        if (row.address && row.address.length < 5) {
            alert("Address: At least 5 characaters required");
            return;
        }

        if (!row.phoneNumber.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/i)) {
            alert("Phone Number is not valid");
            return;
        }

        if (row.aNumber && !row.aNumber.match(/^[0-9]{1,9}/i)) {
            alert("A-Number should be all digits");
            return;
        }

        this.postClient(row);
    }

    renderClients(persons) {

        const options = {
            defaultSortName: 'lastName',
            defaultSortOrder: 'asc'
        };

        return (
            <div>

                <h2>Applicants</h2>

                <div style={{ position: 'absolute', right: 10 }}>
                    <Button bsStyle="link"
                        onClick={() => this.toggleActiveClients()}>
                        Show
                        { this.state.onlyActive ? " Inactive " : " Active " }
                        Applicants</Button>
                </div>

                <Link to="/applicant">
                    <Button bsStyle="info"><Glyphicon glyph="plus" /> New Applicant</Button>
                </Link>

                <BootstrapTable data={persons} bordered={true} striped hover
                    options={options} search={true} searchPlaceholder='Search by any field' >

                    <TableHeaderColumn dataField='id' dataSort isKey={true}
                        hiddenOnInsert width='5%' dataFormat={ColumnFormatter.editClientFormatter}>Id</TableHeaderColumn>

                    <TableHeaderColumn dataField='firstName' dataSort width='20%'>First Name</TableHeaderColumn>

                    <TableHeaderColumn dataField='middleName' hidden dataSort width='1%'>Middle Name</TableHeaderColumn>

                    <TableHeaderColumn dataField='lastName' dataSort width='20%'>Last Name</TableHeaderColumn>

                    <TableHeaderColumn dataField='email' dataSort width='20%'>Email</TableHeaderColumn>

                    <TableHeaderColumn dataField='phoneNumber' width='15%'>Phone</TableHeaderColumn>

                    <TableHeaderColumn dataField='aNumber' hidden width='30%'>A-Number</TableHeaderColumn>

                    <TableHeaderColumn dataField='isActive' dataSort hiddenOnInsert
                        dataFormat={ColumnFormatter.asCheckBox} width='10%'>Is Active</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }

    checkAllCases() {

        let url = `api/PollService/${localStorage.getItem('agency_key')}/case/checkall`;

        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Content-Type': 'application/json'
            }
        };

        fetch(url, requestOptions)
            .then(response => response.json());

        this.forceUpdate();
    }

    toggleActiveClients() {
        let toggle = !this.state.onlyActive;
        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Content-Type': 'application/json'
            }
        };

        fetch(`api/PollService/${localStorage.getItem('agency_key')}/clients/${toggle}`, requestOptions)
            .then(response => response.json())
            .then(data => {
                this.setState({ persons: data, loading: false, onlyActive: toggle });
            });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderClients(this.state.persons);

        return (
            <div>
                {contents}
            </div>



        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Applicant/ApplicantList.js